export interface IOpportunityStrength {
  id: string;
  code: number;
  name: string;
  experience: string;
  locale: string;
  proficiency: string;
}

export class OpportunityStrength {
  public id: string;
  public code: number;
  public name: string;
  public experience: string;
  public locale: string;
  public proficiency: string;

  constructor(data: IOpportunityStrength) {
    this.id = data.id;
    this.code = data.code;
    this.name = data.name;
    this.experience = data.experience;
    this.locale = data.locale;
    this.proficiency = data.proficiency;
  }
}

export interface IStrengthExperienceSelection {
  id: number | undefined;
  term: string;
  experience?: string;
  locale: string;
  proficiency?: string;
  suggested?: boolean;
}

export class StrengthExperienceSelection {
  public id: number | undefined;
  public term: string;
  public experience?: string;
  public locale: string;
  public proficiency?: string;
  public suggested?: boolean;

  constructor(data: IStrengthExperienceSelection) {
    this.id = data.id;
    this.term = data.term;
    this.experience = data.experience;
    this.locale = data.locale;
    this.proficiency = data.proficiency;
    this.suggested = data.suggested;
  }
}
